import CloseIcon from '@mui/icons-material/Close';
import { Modal } from '@mui/material';
import { Dispatch, SetStateAction } from 'react';

import { BannerData } from '../types/General';
import { getEmbedUrl } from '../utils/commonFunctions';
import { BANNER_TYPE } from '../utils/enums';

interface PromotionalDetailModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
  data: BannerData;
}

export default function PromotionalDetailModal({
  open,
  onClose,
  setOpen,
  data,
}: PromotionalDetailModalProps) {
  return (
    <Modal
      className="modal fcDetail_modal"
      id="fcDetailModal"
      aria-labelledby="fcDetail-modal-title"
      aria-describedby="fcDetail-modal-description"
      open={open}
      onClose={onClose}
    >
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="btn-close" onClick={() => setOpen(false)}>
            <CloseIcon />
          </div>
          <div className="modal_title">
            <h2>Promotional Campaigns Details</h2>
          </div>
          <div className="fcustomer_info gap_m">
            <div className="left_s">
              <figure className="blog_dtl_img">
                <img
                  src={data?.image ? data?.image : '/static/images/blog_image.jpg'}
                  alt="fcImage"
                />
              </figure>
            </div>
            <div className="right_s">
              <div className="fcComment_box">
                <h2>User Details</h2>
                <ul className="fcComment_list">
                  <li>
                    <figure
                      style={{
                        width: 60,
                        height: 60,
                      }}
                    >
                      <img
                        src={
                          data?.user?.image ? data?.user?.image : '/static/images/blog_image.jpg'
                        }
                        alt="seller"
                      />
                    </figure>
                    <p>
                      <b>{data?.user?.name}</b>{' '}
                      {`${data?.user?.dialCode || ''}${data?.user?.phoneNo || ''}`} <br />
                      {data?.user?.email}
                    </p>
                  </li>
                </ul>
              </div>
              <div className="details_md">
                <h3>Promotional Campaigns Title</h3>
                <p>{data?.name || '-'}</p>
                <h3>Banner Type</h3>
                <p>{BANNER_TYPE[data?.bannerType] || '-'}</p>
                <h3>Active/Inactive</h3>
                <p>{data?.isEnabled ? 'Active' : 'Inactive'}</p>
              </div>
            </div>
            <div className="details_md">
              <h2>Promotional Video</h2>

              {data?.link?.length !== 0
                ? data?.link?.map((item: any, i: number) => (
                    <div className="control_group " key={i}>
                      {item.linkType === 1 ? (
                        // <div className="control_group w_50 prom_link">
                        <div
                          className=" "
                          style={
                            {
                              // position:'relative',
                            }
                          }
                        >
                          {/* <label>Promotional Video</label> */}
                          <figure>
                            <video controls autoPlay muted src={item?.link} />
                          </figure>
                        </div>
                      ) : (
                        // </div>
                        <div className="control_group w_50 prom_link">
                          <div>
                            {/* <label>Promotional Link</label> */}
                            <p>
                              <iframe
                                src={getEmbedUrl(item.link)}
                                title="Video"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                                width="560"
                                height="315"
                              />
                            </p>
                          </div>
                        </div>
                      )}
                    </div>
                  ))
                : null}
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}
